import { render, staticRenderFns } from "./m_tech017.vue?vue&type=template&id=23786d66&scoped=true&"
import script from "./m_tech017.vue?vue&type=script&lang=js&"
export * from "./m_tech017.vue?vue&type=script&lang=js&"
import style0 from "./m_tech017.vue?vue&type=style&index=0&id=23786d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23786d66",
  null
  
)

export default component.exports